import { GettextInterface } from "@indeed/indeed-gettext"
import { logDatadogRum } from "../datadog"
import { TitleNormStatus, ISalaryType, ISalaryInfo, getSalaryTypeMap } from "./job-info-model"

export function isTitleNormStatusOk(status: TitleNormStatus | undefined): boolean {
    return ["NORMALIZED", "GENERIC", "CATEGORY"].includes(status ?? "")
}

const getSalaryString = (salaryType: ISalaryType, currencySymbol: string, pay: string, gettext: GettextInterface["gettext"]) => {
    switch (salaryType) {
        case "HOURLY":
            return gettext("{0}{1} per hour", [currencySymbol, pay])
        case "DAILY":
            return gettext("{0}{1} per day", [currencySymbol, pay])
        case "WEEKLY":
            return gettext("{0}{1} per week", [currencySymbol, pay])
        case "MONTHLY":
            return gettext("{0}{1} per month", [currencySymbol, pay])
        case "YEARLY":
            return gettext("{0}{1} per year", [currencySymbol, pay])
        case "BIWEEKLY":
            return gettext("{0}{1} biweekly", [currencySymbol, pay])
        case "QUARTERLY":
            return gettext("{0}{1} per quarter", [currencySymbol, pay])
        default:
            return ""
    }
}

export const constructSalaryString = (
    gettext: GettextInterface["gettext"],
    salaryInfo?: ISalaryInfo,
    useNewSalaryString = false
): string => {
    if (salaryInfo?.payRate == null) {
        return ""
    }
    if (!(typeof salaryInfo.payRate === "number" && !Number.isNaN(salaryInfo.payRate)) || typeof salaryInfo.currencySymbol !== "string") {
        const error = new Error("constructSalaryString: parameter 'salaryInfo' type is invalid.")
        logDatadogRum(error, { salaryInfo })
        return ""
    }

    const payRateStr = salaryInfo.payRate.toLocaleString(
        undefined,
        salaryInfo.payRate % 1 === 0 ? undefined : { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    )

    if (useNewSalaryString) {
        return getSalaryString(salaryInfo.salaryType ?? "NONE", salaryInfo.currencySymbol, payRateStr, gettext)
    }
    return `${salaryInfo.currencySymbol}${payRateStr} ${getSalaryTypeMap(gettext)[salaryInfo.salaryType ?? "NONE"]}`
}
